import React from 'react';
import clsx from 'clsx';

import Brand from '../components/Brand';
import Button from '../components/Button';

import infoWindowStyles from '../components/InfoWindow.module.scss';

import { getCompleteAddress } from './newCarUtil';

import {
	AGENCY_PROJECT,
	PROJECT_CAR,
	PROJECT_CSV,
	PIN_PROP,
	DATA_SRC_TYPES,
	PROJECT_CRI,
	RESTURANTS,
	FUEL,
	FILIALI_PROJECT,
	PROJECT_CAR_NEW,
	MOCK_CAR_URL,
	PROJECT_GOOGLE,
	PROJECT_CAR2,
	PROJECT_GRA
} from '../utils/Constants';

import { useNormalResult } from './normalizeResults';
import { getCarType } from './geocmsUtil';

export function useDataSources() {
	const [, , normalizeBaseResult] = useNormalResult();

	const DATA_SRCS = [
		{
			type: DATA_SRC_TYPES.GeoCMS,
			key: AGENCY_PROJECT,
			label: 'Agenzie',
			icon: 'icon/agente_blue.png',
			tcEventName: 'SEZIONE_TROVAAGENTE'
		},
		{
			type: DATA_SRC_TYPES.GeoCMS,
			key: FILIALI_PROJECT,
			label: 'Filiali',
			icon: 'icon/agente_blue.png',
			tcEventName: 'SEZIONE_TROVAFILIALI'
		},
		{
			type: DATA_SRC_TYPES.GeoCMS,
			key: PROJECT_CAR,
			label: 'Carrozzerie',
			icon: 'icon/carrozzerie_blue.png',
			tcEventName: 'SEZIONE_CARROZZERIECONVENZIONATE'
		},
		// {
		// 	type: DATA_SRC_TYPES.GeoCMS,
		// 	key: PROJECT_CAR,
		// 	label: 'Officine',
		// 	icon: 'cerca_officine.svg'
		// },
		{
			type: DATA_SRC_TYPES.GeoCMS,
			key: PROJECT_CRI,
			label: 'Cristalli',
			icon: 'icon/cristalli_toolkit.png',
			tcEventName: 'SEZIONE_CRISTALLI'
		},
		{
			type: DATA_SRC_TYPES.GeoCMS,
			key: PROJECT_GRA,
			label: 'Grandine',
			icon: 'icon/grandine_toolkit.png',
			tcEventName: 'SEZIONE_GRANDINE'
		},
		{
			type: DATA_SRC_TYPES.GeoCMS,
			key: PROJECT_CSV,
			label: 'Centri salute',
			icon: 'icon/salute_vita_blue.png',
			tcEventName: 'SEZIONE_CENTRISALUTE'
		},
		{
			type: DATA_SRC_TYPES.GooglePlaces,
			query: 'pizzeria',
			key: RESTURANTS,
			label: 'Ristoranti',
			icon: 'icon/telefono_blue.png',
			normalizeResult: (result) => {
				return normalizeBaseResult(
					'Ristoranti_' + result.place_id,
					'Ristoranti',
					result.name,
					result.geometry.location.lat(),
					result.geometry.location.lng(),
					{
						main:
							'https://icon-library.com/images/icon-pin/icon-pin-19.jpg',
						highlighted:
							'https://iconsplace.com/wp-content/uploads/_icons/ffa500/256/png/pin-icon-11-256.png'
					},
					result.formatted_address,
					result.driveDistance,
					'CTA TEST',
					null,
					null,
					null,
					null,
					null,
					<Brand img={result.icon} />,
					null
				);
			}
		},
		{
			type: DATA_SRC_TYPES.GooglePlaces,
			query: 'benzinaio',
			key: FUEL,
			label: 'Benzinai',
			icon: 'icon/telefono_blue.png',
			normalizeResult: (result) => {
				const normalizedResult = normalizeBaseResult(
					'Benzinai_' + result.place_id,
					FUEL,
					result.name,
					result.geometry.location.lat(),
					result.geometry.location.lng(),
					PIN_PROP.IMGs.DEFAULT,
					result.formatted_address,
					result.driveDistance,
					'CTA TEST',
					null,
					null,
					null,
					null,
					null,
					<Brand img={result.icon} />,
					null
				);

				normalizedResult.infoWindowFooter = (
					<Button
						variant="special"
						className={clsx(infoWindowStyles.button, 'cta')}
						text={normalizedResult.cta}
						link="http://google.com"
					/>
				);
				return normalizedResult;
			}
		},
		{
			type: DATA_SRC_TYPES.URL,
			url: MOCK_CAR_URL,
			resultsListProp: 'data',
			key: PROJECT_CAR_NEW,
			label: 'Nuove carrozzerie',
			icon: 'icon/carrozzerie_blue.png',
			getLocation: (result) => {
				return {
					lat: () =>
						result.attributes.geographicalAddress
							.globalPositionAddress.latitude,
					lng: () =>
						result.attributes.geographicalAddress
							.globalPositionAddress.longitude
				};
			},
			processURL: function (lat, lng) {
				return defaultProcessURLFnc(this.url, lat, lng);
			},
			normalizeResult: (result) => {
				const data = result.attributes;
				const geoData = data.geographicalAddress;

				const type = getCarType(data);

				const imgModule = require('../images/car.png');
				const img = imgModule.default || imgModule;

				const normalizedResult = normalizeBaseResult(
					PROJECT_CAR_NEW +
						data.code +
						Math.floor(Math.random() * 1000),
					PROJECT_CAR_NEW,
					data.name,
					parseFloat(geoData.globalPositionAddress.latitude),
					parseFloat(geoData.globalPositionAddress.longitude),
					PIN_PROP.IMGs.DEFAULT,
					getCompleteAddress(geoData),
					result.driveDistance,
					'Prenota Qui',
					data.contact.telephone,
					data.contact.fax,
					data.contact.email,
					null,
					null,
					<Brand img={img} content={type || 'Nuova Carrozzeria'} />,
					null
				);

				normalizedResult.infoWindowFooter = (
					<Button
						variant="special"
						className={clsx(infoWindowStyles.button, 'cta')}
						text={normalizedResult.cta}
						link="http://google.com"
					/>
				);

				return normalizedResult;
			}
		}
	];

	function getDataSource(key) {
		let dataSrc;

		for (let i = 0; i < DATA_SRCS.length; i++) {
			const data = DATA_SRCS[i];

			if (data.key == key) {
				dataSrc = data;
			}
		}
		return dataSrc;
	}

	return [DATA_SRCS, getDataSource];
}

function defaultProcessURLFnc(url, lat, lng) {
	let processedURL = url;

	processedURL = processedURL.replace('${lat}', lat);
	processedURL = processedURL.replace('${lng}', lng);

	return processedURL;
}
